function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarehouseIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "warehouse-in",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 508 508",
    style: {
      enableBackground: "new 0 0 508 508"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#4CDBC4"
    },
    cx: 254,
    cy: 254,
    r: 254
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C9984"
    },
    d: "M65.9,424.6C112.3,475.8,179.4,508,254,508s141.7-32.2,188.1-83.4H65.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "423.5,149.3 423.5,424.6 84.5,424.6 84.5,149.3 254,93.8 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.5,
    y: 399.1,
    style: {
      fill: "#E6E9EE"
    },
    width: 338.9,
    height: 25.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.1,
    y: 238.6,
    style: {
      fill: "#324A5E"
    },
    width: 261.8,
    height: 186
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.5,
    y: 273.4,
    style: {
      fill: "#FFD05B"
    },
    width: 206.2,
    height: 151.3
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B54C"
    },
    d: "M358.6,313.3v-2h-40.2v-37.9h-1.6v37.9H276v-37.9h-1.6v37.9h-40.8v-37.9H232v37.9h-40.8v-37.9h-1.6 v37.9h-37.1v2h37.1V348h-37.1v2h37.1v34.7h-37.1v2h37.1v37.1h1.6v-37.1H232v37.1h1.6v-37.1h40.8v37.1h1.6v-37.1h40.8v37.1h1.6v-37.1 h40.2v-2h-40.2V350h40.2v-2h-40.2v-34.7H358.6z M232,384.7h-40.8V350H232V384.7z M232,348h-40.8v-34.7H232V348z M274.4,384.7h-40.8 V350h40.8V384.7z M274.4,348h-40.8v-34.7h40.8V348z M316.8,384.7H276V350h40.8V384.7z M316.8,348H276v-34.7h40.8V348z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 166.8,
    style: {
      fill: "#E6E9EE"
    },
    width: 71.6,
    height: 25.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.2,
    y: 166.8,
    style: {
      fill: "#E6E9EE"
    },
    width: 71.6,
    height: 25.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.3,
    y: 166.8,
    style: {
      fill: "#E6E9EE"
    },
    width: 71.6,
    height: 25.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.3,
    y: 273.4,
    style: {
      fill: "#E6E9EE"
    },
    width: 11,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.4,
    y: 273.4,
    style: {
      fill: "#E6E9EE"
    },
    width: 11,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.5,
    y: 273.4,
    style: {
      fill: "#E6E9EE"
    },
    width: 11,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.6,
    y: 273.4,
    style: {
      fill: "#E6E9EE"
    },
    width: 11,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.7,
    y: 273.4,
    style: {
      fill: "#E6E9EE"
    },
    width: 11,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.3,
    y: 313.1,
    style: {
      fill: "#E6E9EE"
    },
    width: 11,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.4,
    y: 313.1,
    style: {
      fill: "#E6E9EE"
    },
    width: 11,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.5,
    y: 313.1,
    style: {
      fill: "#E6E9EE"
    },
    width: 11,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.6,
    y: 313.1,
    style: {
      fill: "#E6E9EE"
    },
    width: 11,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.7,
    y: 313.1,
    style: {
      fill: "#E6E9EE"
    },
    width: 11,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.3,
    y: 349.9,
    style: {
      fill: "#E6E9EE"
    },
    width: 11,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.4,
    y: 349.9,
    style: {
      fill: "#E6E9EE"
    },
    width: 11,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.5,
    y: 349.9,
    style: {
      fill: "#E6E9EE"
    },
    width: 11,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.6,
    y: 349.9,
    style: {
      fill: "#E6E9EE"
    },
    width: 11,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.7,
    y: 349.9,
    style: {
      fill: "#E6E9EE"
    },
    width: 11,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.3,
    y: 386.6,
    style: {
      fill: "#E6E9EE"
    },
    width: 11,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.4,
    y: 386.6,
    style: {
      fill: "#E6E9EE"
    },
    width: 11,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.5,
    y: 386.6,
    style: {
      fill: "#E6E9EE"
    },
    width: 11,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.6,
    y: 386.6,
    style: {
      fill: "#E6E9EE"
    },
    width: 11,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.7,
    y: 386.6,
    style: {
      fill: "#E6E9EE"
    },
    width: 11,
    height: 4.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouseIn);
export default __webpack_public_path__ + "static/media/warehouse-in.48ccb2b0ea5232ff71f95473fa671a77.svg";
export { ForwardRef as ReactComponent };